module.exports = __webpack_public_path__ + "img/VisitorDefaultSlideCC.3ce014fd.png";